import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CreateOrGetOrganizationCommand as CreateOrGetOrganizationDto } from '../../../../models/identity/create-or-get-organization-command.model';
import { Organization } from '../../../../models/identity/organization.model';
import { OrganizationService } from '../../../../services/identity/organization.service';
import { CommunityMemberApiService } from '../../../infrastructure/community-member-api.service';
import { MemberOrganizationDto } from '../../../models/member-organization-dto.model';
import { InviteMemberDto } from './invite-member-dto.model';

export interface InviteMemberCommand {
    email: string;
    firstName: string;
    lastName: string;
    organizationInput: string | Organization; // Peut être un string (nouvelle orga) ou un objet (orga existante)
    isOrganizationManager: boolean;
    communitiesIds: string[];
    primaryCommunityId: string;
}

@Injectable({
    providedIn: 'root',
})
export class InviteMemberUseCase {
    constructor(private readonly organizationService: OrganizationService, private readonly communityMemberApiService: CommunityMemberApiService) {}

    public execute(command: InviteMemberCommand): Observable<void> {
        const { email, firstName, lastName, organizationInput, isOrganizationManager, communitiesIds, primaryCommunityId } = command;

        let organization$: Observable<Organization>;
        if (typeof organizationInput === 'string') {
            const createOrGetCommand: CreateOrGetOrganizationDto = {
                organizationName: organizationInput,
                email: email,
                communities: communitiesIds,
                primaryCommunityId: primaryCommunityId,
            };
            organization$ = this.organizationService.createOrGetOrganization(createOrGetCommand);
        } else {
            organization$ = of(organizationInput);
        }

        return organization$.pipe(
            switchMap((organization) => {
                const memberDto: InviteMemberDto = {
                    email: email.toLowerCase(),
                    firstName: firstName,
                    lastName: lastName,
                    organization: {
                        id: organization.id,
                        isManager: isOrganizationManager,
                    } as MemberOrganizationDto,
                    communities: communitiesIds,
                    primaryCommunityId: primaryCommunityId,
                };
                return this.communityMemberApiService.inviteMember(memberDto);
            }),
        );
    }
}
